const Page = ({ className, children }) => {
  return <section className={`bg-theme-primary text-theme-text min-w-[300px] h-full ${className}`}>{children}</section>;
};

export default Page;
